export default __webpack_public_path__ + "static/media/head03_th_pc.5b02881d.png";